var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyLiveListEmpty = function SvgMyLiveListEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_45824)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#F5F4EE",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M94 23v22m11-11H83"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BF1424",
    clipPath: "url(#clip1_2153_45824)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.18,
    height: 55.71,
    x: 37.343,
    y: 66.037,
    strokeWidth: 7.8,
    rx: 9.266,
    transform: "rotate(13.47 37.343 66.037)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 7.523,
    d: "m86.758 65.533-10.447 8.414M60.774 59.622l5.332 12.311"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.523,
    d: "M77.342 105.14 58.459 87.078l-6.134 25.608z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_45824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#fff",
    rx: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2153_45824"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.03 45 87.799 21.03-21.03 87.799-87.8-21.03z"
  })))));
};
export default SvgMyLiveListEmpty;